<template class="pendencyBody">
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>

    <b-card class="mainCardBG">
      <b-row>
        <b-navbar-nav>

        </b-navbar-nav>

        <b-col md="2">
          <h5 class="page-title mb-2">
            <b>Common BL Dash</b>
          </h5>
        </b-col>
        <b-col md="2">
          <label>Branch</label>

          <model-list-select class="ml-1" :list="$store.getters['common/getAllFilterBranchList']" id="branchfilter"
            v-model="Filter.branchFilter" option-value="value" option-text="text" placeholder="All"
            @input="debounceSearch"></model-list-select>
        </b-col>

        <b-col md="2">
          <label>Sob Status</label>
          <model-list-select @input="debounceSearch" :list="SOBStatusList" v-model="Filter.SobFilter" option-value="inv"
            option-text="int" placeholder="Select SOB Status"></model-list-select>
        </b-col>
        <b-col md="2">
          <label>Prealert Status</label>
          <model-list-select @input="debounceSearch" :list="PrealertStatusList" v-model="Filter.prealertStatus"
            option-value="inv" option-text="int" placeholder="Select Prealert Status"></model-list-select>
        </b-col>
        <b-col md="2">
          <label>Billing Status</label>
          <model-list-select @input="debounceSearch" :list="BillingStatusList" v-model="Filter.isFinalBillingStatus"
            option-value="inv" option-text="int" placeholder="Select Billing Status"></model-list-select>
        </b-col>
        <b-col md="2">
          <label for="dateDropdown">SI Due Date:</label>
          <model-list-select :list="next7Days" id="SiDueDateFilter" @input="debounceSearch"
            v-model="Filter.SiDueDateFilter" option-value="value" option-text="label"
            placeholder="Select SI Due Date" />

        </b-col>
        <b-col md="2">
          <label for="dateDropdown">TR Due Date:</label>
          <model-list-select :list="next7Days" id="TrDueDateFilter" @input="debounceSearch"
            v-model="Filter.TrDueDateFilter" option-value="value" option-text="label"
            placeholder="Select TR Due Date" />
        </b-col>
        <b-col md="2">
          <label for="dateDropdown">VGM Due Date:</label>
          <model-list-select :list="next7Days" id="VgmDueDateFilter" @input="debounceSearch"
            v-model="Filter.VgmDueDateFilter" option-value="value" option-text="label"
            placeholder="Select VGM Due Date" />
        </b-col>
        <b-col md="2">
          <b-button
            v-if="($sessionsStorage.get('cust_username') == 'rathishnair' || ($sessionsStorage.get('designation') == 'Admin' &&
              $sessionsStorage.get('nameUser') == 'Bhavneesh') || $sessionsStorage.get('designation') == 'Admin')"
            class="pull-right ml-2 mt-5" @click="sendSlinePaymentRequest" size="sm" variant="outline-primary">Send Sline
            Payment
            <b-spinner v-if="isLoading" small label="Small Spinner"></b-spinner></b-button>
        </b-col>
      </b-row>

      <div class="mt-3">
        <!-- Search Form Input Start -->
        <b-row>
          <b-col md="6" class="my-1">
            <b-form-group>
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="Filter.commonFilter"
                  placeholder="Type to Search Assignment" ref="search" />
                <b-input-group-append class="mr-1">
                  <b-button :disabled="!Filter.commonFilter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>

              <b-col md="3">

              </b-col>
            </b-form-group>
          </b-col>

          <b-col md="5">
            <!-- <b-button 
              :pressed="activeButtonBranch" 
              v-model="activeButtonBranch"
              :variant="activeButtonBranch ? 'success' : 'danger'" 
              @click="BranchBtnFilter(activeButtonBranch)"
            >
              Branch {{ activeButtonBranch ? " Filter On" : " Filter Off" }}
            </b-button> -->
            <b-button class="pull-right ml-1" :variant="Filter.userFilter ||
              Filter.branchFilter ||
              Filter.prealertStatus ||
              Filter.SobFilter ||
              Filter.isFinalBillingStatus ||
              Filter.SiDueDateFilter ||
              Filter.TrDueDateFilter ||
              Filter.VgmDueDateFilter ||
              Filter.liner_bl_release_statusFilter ||
              Filter.line_inv_statusFilter ||
              Filter.commonFilter ||
              Filter.createdAtRange.startDate ||
              Filter.createdAtRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' pull-right mb-1' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.userFilter ||
                  Filter.branchFilter ||
                  Filter.prealertStatus ||
                  Filter.SobFilter ||
                  Filter.isFinalBillingStatus ||
                  Filter.SiDueDateFilter ||
                  Filter.TrDueDateFilter ||
                  Filter.VgmDueDateFilter ||
                  Filter.liner_bl_release_statusFilter ||
                  Filter.line_inv_statusFilter ||
                  Filter.commonFilter ||
                  Filter.createdAtRange.startDate ||
                  Filter.createdAtRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>

            <b-button class="pull-right mb-1" v-if="JOBList.length > 0" :disabled="ExcelBtnName !== 'Export As Excel'"
              @click="getReports('checkJobPendency', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName !== 'Export As Excel'" small label="Small Spinner"></b-spinner>
            </b-button>

            <b-button class="pull-right mb-1" v-if="JOBList.length > 0"
              :disabled="ExcelBtnNameCustom !== 'SI VGM Pending'"
              @click="getReportsCustom('checkJobPendency', 'SI VGM Pending')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnNameCustom }}
              <b-spinner v-if="ExcelBtnNameCustom !== 'SI VGM Pending'" small label="Small Spinner"></b-spinner>
            </b-button>
            <userBasedClient v-if="$sessionsStorage.get('userId')"
              :PMC_title="'User Summary - ' + $sessionsStorage.get('employeeName')" :PMC_USERID="Filter.userFilter"
              :PMC_USERNAME="$sessionsStorage.get('nameUser')" :PMC_USERDESIG="$sessionsStorage.get('designation')"
              :PMC_BranchClientPre="$sessionsStorage.get('branchclientPre')"
              :PMC_TransportTypePre="$sessionsStorage.get('transportTypePre')"
              :PMC_UserEmpName="$sessionsStorage.get('employeeName')"
              :PMC_UserEmpCode="$sessionsStorage.get('employeeCode')" />
          </b-col>

          <b-col md="1">
            <h5>
              <small v-if="!isLoading">{{ totalData }} Entries</small>
            </h5>
          </b-col>
        </b-row>

        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.createdAtRange"
                    :startDate="startDate" :endDate="endDate" :locale-data="locale"
                    @update="getAssignmentPendencyList('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label v-if="activeUserPreference">
                    <b>Created User Filter</b>
                  </label>
                  <model-list-select v-if="activeUserPreference" :list="$store.getters['common/getAllUserList']"
                    id="addedUserFilter" @input="debounceSearch" v-model="Filter.userFilter" option-value="userId"
                    option-text="employeeName" placeholder="Select Created User" />
                </b-col>
                <b-col md="3">
                  <label for="dateDropdown">SI Due Date:</label>
                  <model-list-select :list="next7Days" id="SiDueDateFilter" @input="debounceSearch"
                    v-model="Filter.SiDueDateFilter" option-value="value" option-text="label"
                    placeholder="Select SI Due Date" />

                </b-col>
                <b-col md="3">
                  <label for="dateDropdown">TR Due Date:</label>
                  <model-list-select :list="next7Days" id="TrDueDateFilter" @input="debounceSearch"
                    v-model="Filter.TrDueDateFilter" option-value="value" option-text="label"
                    placeholder="Select TR Due Date" />
                </b-col>
                <b-col md="3">
                  <label for="dateDropdown">VGM Due Date:</label>
                  <model-list-select :list="next7Days" id="VgmDueDateFilter" @input="debounceSearch"
                    v-model="Filter.VgmDueDateFilter" option-value="value" option-text="label"
                    placeholder="Select VGM Due Date" />
                </b-col>
                <b-col cols="3">
                  <label for="liner-bl-release-status">Liner BL Release Status</label>
                  <model-list-select :list="mblInvoiceStatus" id="liner_bl_release_status" @input="debounceSearch"
                    v-model="Filter.liner_bl_release_statusFilter" option-value="value" option-text="label"
                    placeholder="Select MBL Status" />
                </b-col>
                <b-col cols="3">
                  <label for="liner-bl-release-status">Line Invoice Status</label>
                  <model-list-select :list="lineInvoiceStatus" id="line_inv_status" @input="debounceSearch"
                    v-model="Filter.line_inv_statusFilter" option-value="value" option-text="label"
                    placeholder="Select Line Invoice Status" />
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
          :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
        <div class="col-md-12 row table-wrapper-scroll-x my-custom-scrollbar">

          <b-table show-empty stacked="md" responsive :fields="columnMain" :items="JOBList"
            class="table-background position-relative" :per-page="pagination.perPage" :filter="filter"
            @filtered="onFiltered">
            <!--  -->
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage }}</span>
            </template>
            <template slot="RaisedFrom" slot-scope="row1">
              <tr :class="{ blink: isBlinking(row1.item) }">
                <td>
                  <div :class="{ 'blink-circle': shouldBlink(row1.item) }"></div>
                </td>
              </tr>
              <span>{{ row1.item.RaisedFrom }}</span><br />
              <b-badge :variant="row1.item.SobStatus == 'Sailed' ? 'success' : 'danger'"><b>SOB:{{ row1.item.SobStatus
              }}</b></b-badge><br />
              <b-badge :variant="row1.item.BillingStatus == 'Completed' ? 'success' : 'danger'"><b>Billing:{{
                row1.item.BillingStatus }}</b></b-badge><br />
              <b-badge
                :variant="(row1.item.PrealertStatus == 'Prealert Sent (FF)' || row1.item.PrealertStatus == 'Prealert Sent (CON)') ? 'success' : 'danger'"><b>Prealert:{{
                  row1.item.PrealertStatus }}</b></b-badge><br />
              <span v-if="row1.item.isConsolidation == 0">{{ "Prealert : " + row1.item.IsPrealertSend }}</span><br />
              <span v-if="row1.item.isConsolidation == 1">{{ "Prealert : " + row1.item.IsCONprealertSend }}</span><br />
              <span>{{ "Manifest : " + row1.item.IsManifestationStatus }}</span><br />
              <span>{{ "Transport Type : " + row1.item.TransportType }}</span><br />
              <span>{{ "Job Type : " + row1.item.JobType }}</span><br />
              <span>{{ "FCL/LCL : " + row1.item.FCL_LCL }}</span><br />
              <span>{{ "Stuffing Type : " + row1.item.StuffingType }}</span><br />
              <span>{{ "Delivery Mode : " + row1.item.DeliveryMode }}</span><br />
              <span>{{ "Delivery Terms : " + row1.item.DeliveryTerms }}</span>
              <!-- <span>{{ "Billing : " + row1.item.TallyBillingSeries }}</span> -->
              <span>Billing : </span>
              <div class="text-left" v-if="row1.item.TallyBillingSeries">
                <div v-if="row1.item.TallyBillingSeries">
                  <span v-for="(item1, index) in row1.item.TallyBillingSeries.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
              <div class="text-left" v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
              <b-button size="sm" style="margin-left: auto; font-size: 0.675rem" class="ml-1" variant="outline-danger"
                @click="openModal(row1.item)">
                Update
              </b-button>
              <UpdateCBModal ref="updateCBModal" :common_id="row1.item.common_id" :allModuleId="row1.item.allModuleId"
                :JobNo="row1.item.JOBNO" :booking_id="row1.item.booking_id"
                :getin_due_date="row1.item.common_getin_due_date || row1.item.cb_getin_due_date"
                :si_submission_date="row1.item.common_si_submission_date || row1.item.cb_si_submission_date"
                :vgm_submission_date="row1.item.common_vgm_submission_date || row1.item.cb_vgm_submission_date"
                :tr_submission_date="row1.item.common_tr_submission_date || row1.item.cb_tr_submission_date"
                :liner_bl_release_status="row1.item.common_liner_bl_release_status || row1.item.cb_liner_bl_release_status"
                :line_inv_status="row1.item.common_line_inv_status || row1.item.cb_line_inv_status"
                :linerBLNumber="row1.item.MblNo || ''" :blType="row1.item.blType || ''"
                :frghtTermsLiner="row1.item.frghtTermsLiner || ''" :linerBLupload="row1.item.linerBLupload || ''"
                :mbl_release_date="row1.item.mbl_release_date || ''" :mbl_date="row1.item.mbl_date || ''"
                @update="updateData" />
              <b-button class="mt-2" style="font-size: 0.675rem" size="sm" @click="showDocModal(row1.item)"
                variant="outline-info">Summary & Documents</b-button>
              <Assignment-Summary :title="'Shipment Summary Tracking - '" :fk_all_module_id="row1.item.allModuleId"
                :jb_series="row1.item.JobNo" />
              <JobWisePaymentsDetails v-if="row1.item.allModuleId" :allModuleId="Number(row1.item.allModuleId)"
                :JobNo="row1.item.JobNo" />
              <ContainerSummary v-if="row1.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row1.item.JobNo"
                :PMC_JOBID="row1.item.allModuleId.toString()" :PMC_JOBNO="row1.item.JobNo"
                :PMC_JOBDATE="row1.item.JobDate" :PMC_JOBTYPE="row1.item.JobType" :PMC_AgentType="''"
                :PMC_Client="row1.item.ClientName" :PMC_Sline="row1.item.ShippingLine" />
              <RejectInvTallyBillSummary v-if="row1.item.allModuleId" :PMC_title="'Invoice Rejection Log Summary Job No - ' + row1.item.ffExportFclSeries
                " :PMC_JOBID="row1.item.allModuleId.toString()" :PMC_JOBNO="row1.item.JobNo" :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''" :PMC_Client="''" :PMC_Sline="''" />
              <InvExpSummary v-if="row1.item.allModuleId" :PMC_title="'Inv Exp Summary Job No - ' + row1.item.JobNo"
                :PMC_JOBID="row1.item.allModuleId.toString()" :PMC_JOBNO="row1.item.JobNo"
                :PMC_JOBDATE="row1.item.JobDate" :PMC_JOBTYPE="row1.item.JobType" :PMC_AgentType="''" :PMC_Client="''"
                :PMC_Sline="row1.item.ShippingLine" />
            </template>
            <template slot="BookingNo" slot-scope="row2">
              <span :style="row2.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''"
                @click="row2.item.SubscriptionId ? goToSubscriptionPage(row2.item) : ''">{{ row2.item.BookingNo
                }}</span><br />
              <span>{{ "Billing Type : " + row2.item.IsBillingTypeStatus }}<br /></span>
              <span v-if="
                row2.item.IsBillingTypeStatus == 'Local' ||
                row2.item.IsBillingTypeStatus == 'Both'
              ">{{
                "Local : " +
                (row2.item.billingTypeMain == "Local Billing" ? "Done" : "Pending")
              }}<br /></span>
              <span v-if="
                row2.item.IsBillingTypeStatus == 'Overseas' ||
                row2.item.IsBillingTypeStatus == 'Both'
              ">{{
                "Overseas : " +
                (row2.item.IsManifestation == "Yes" ? "Done" : "Pending")
              }}<br /></span>
              <span v-if="row2.item.blType">{{ "BL Type : " + row2.item.blType }}<br /></span>
              <span v-if="row2.item.frghtTermsHbl">{{ "Freight Terms Hbl : " + row2.item.frghtTermsHbl }}<br /></span>
              <span v-if="row2.item.frghtTermsMbl">{{ "Freight Terms Mbl : " + row2.item.frghtTermsMbl }}<br /></span>
              <span v-if="row2.item.frghtTermsLiner">{{ "Freight Terms Liner : " + row2.item.frghtTermsLiner
              }}<br /></span>
            </template>
            <template slot="JOBNO" slot-scope="row3">
              <tr :class="{ blink: isBlinking(row3.item) }" @click="goPage(row3.item)">
                <td>
                  <span>{{ "JOBNO : " + row3.item.JobNo }}</span><br />
                </td>
              </tr>

              <span>{{ "JOBDate : " + row3.item.JobDate }}</span><br />
              <span>{{ "RaisedBy : " + row3.item.RaisedBy }}</span><br />
              <span>{{ "MBLNO : " + row3.item.MblNo }}</span><br />
              <span>{{ "HBLNO : " + row3.item.HblNo }}</span><br />
              <span>{{ "Tot Cont : " + row3.item.TotalContainerNo }}</span><br />
              <div class="text-left" v-if="row3.item.FreightContainers">
                <div v-if="row3.item.FreightContainers">
                  <span v-for="(item1, index) in row3.item.FreightContainers.split(',')" :key="index">
                    <h6>
                      <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                      </b-badge>
                    </h6>
                    <ContaierWebLogSummary v-if="row3.item.allModuleId && item1"
                      :PMC_title="'Container Event Summary Job No - ' + row3.item.JobNo"
                      :PMC_JOBID="row3.item.allModuleId.toString()" :PMC_JOBNO="row3.item.JobNo" :PMC_CONTNO="item1"
                      :PMC_JOBDATE="''" :PMC_JOBTYPE="''" :PMC_AgentType="''" :PMC_Client="''" :PMC_Sline="''" />
                  </span>
                </div>
              </div>
              <div class="text-left" v-else>
                <b-badge variant="light">-------</b-badge>
              </div>
              <!-- <span>{{ "Containers : " + row3.item.freightContainers }}</span><br /> -->
            </template>
            <template slot="clientName" slot-scope="row4">
              <span>{{ row4.item.ClientName }}</span><br />
              <span>{{ "FF Status : " + row4.item.FFInvStatus }}</span><br />
              <span>{{ "CC Status : " + row4.item.CCInvStatus }}</span><br />
              <span>{{ "TPT Status : " + row4.item.TPTInvStatus }}</span><br />
            </template>
            <template slot="shippingLine" slot-scope="row5">
              <span>{{ row5.item.ShippingLine }}</span><br />
              <span>{{ "Vessel Voyage : " + row5.item.VesselVoyage }}</span><br />
              <span>{{ "SINVNO : " }}</span><br />
              <div class="text-left" v-if="row5.item.SINVNO">
                <div v-if="row5.item.SINVNO">
                  <span v-for="(item1, index) in row5.item.SINVNO.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
              <span>{{ "SBILLNO : " }}</span><br />
              <div class="text-left" v-if="row5.item.SBILLNO">
                <div v-if="row5.item.SBILLNO">
                  <span v-for="(item1, index) in row5.item.SBILLNO.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
              <span>{{ "CUST_SEAL_NO : " }}</span><br />
              <div class="text-left" v-if="row5.item.CUST_SEAL_NO">
                <div v-if="row5.item.CUST_SEAL_NO">
                  <span v-for="(item1, index) in row5.item.CUST_SEAL_NO.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
              <span>{{ "LINE_SEAL_NO : " }}</span><br />
              <div class="text-left" v-if="row5.item.LINE_SEAL_NO">
                <div v-if="row5.item.LINE_SEAL_NO">
                  <span v-for="(item1, index) in row5.item.LINE_SEAL_NO.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
            </template>
            <template slot="POR" slot-scope="row6">
              <span>{{ "POR : " + row6.item.POR }}</span><br />
              <span>{{ "POL : " + row6.item.POL }}</span><br />
              <span>{{ "POD : " + row6.item.POD }}</span><br />
              <span>{{ "FPOD : " + row6.item.FPOD }}</span><br />
              <span>{{ "Inv Reverse : " }}</span><br />
              <div class="text-left" v-if="row6.item.invReverse">
                <div v-if="row6.item.invReverse">
                  <span v-for="(item1, index) in row6.item.invReverse.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
              <span>{{ "Inv Expense : " }}</span><br />
              <div class="text-left" v-if="row6.item.invExpense">
                <div v-if="row6.item.invExpense">
                  <span v-for="(item1, index) in row6.item.invExpense.split(',')" :key="index">
                    <b-badge variant="light"><b>{{ item1 == "" ? "-------" : item1 }}</b></b-badge><br />
                  </span>
                </div>
              </div>
            </template>
            <template slot="vgmcut_off_date_est" slot-scope="row10">

              <span :class="row10.item.VgmSubmissionDateActual == 'Pending' ? 'error' : ''"
                @click="goVGMPage(row10.item)">{{ row10.item.VgmSubmissionDateActual }}</span>/
              <span :class="row10.item.VgmCutOffDateEst == 'Pending' ? 'error' : ''" @click="goVGMPage(row10.item)">{{
                row10.item.VgmCutOffDateEst }}</span><br />

              <span :class="row10.item.VgmDueDate == 'Pending' ? 'error' : ''">{{ "VGM Due date : " +
                row10.item.VgmDueDate }}</span>

            </template>
            <template slot="si_cutoff_est" slot-scope="row11">
              <span :class="row11.item.SiSubmissiondateActual == 'Pending' ? 'error' : ''"
                @click="goVGMPage(row11.item)">{{ row11.item.SiSubmissiondateActual }}</span>/
              <span :class="row11.item.SiCutOffEst == 'Pending' ? 'error' : ''" @click="goVGMPage(row11.item)">{{
                row11.item.SiCutOffEst }}</span><br />
              <span :class="row11.item.SiDueDate == 'Pending' ? 'error' : ''">{{ "SI Due date : " +
                row11.item.SiDueDate }}</span>

            </template>
            <template slot="tr_cutoff_date_est" slot-scope="row12">
              <span :class="row12.item.TrSubmissiondateActual == 'Pending' ? 'error' : ''"
                @click="goVGMPage(row12.item)">{{ row12.item.TrSubmissiondateActual }}</span>/
              <span :class="row12.item.TrCutOffDateEst == 'Pending' ? 'error' : ''" @click="goVGMPage(row12.item)">{{
                row12.item.TrCutOffDateEst }}</span><br />

              <span :class="row12.item.TrDueDate == 'Pending' ? 'error' : ''">{{ "TR Due date : " +
                row12.item.TrDueDate }}</span>

            </template>

            <template slot="handoverDate_actual" slot-scope="row12">
              <span :class="row12.item.HandoverDateActual == 'Pending' ? 'error' : ''">{{
                row12.item.HandoverDateActual
              }}</span>/
              <span :class="row12.item.HandoverCutOffDateEst == 'Pending' ? 'error' : ''">{{
                row12.item.HandoverCutOffDateEst }}</span>

            </template>

            <template slot="oe_payment_status" slot-scope="row13">
              <span>{{ "Payment Status : " + row13.item.SlinePaymentStatus }}</span><br />

              <span :class="row13.item.SlineFirstPayDate == 'Pending' ? 'error' : ''">{{ "Payment First Date : " +
                row13.item.SlineFirstPayDate }}</span>
              <span :class="row13.item.OfFirstPaymentDate == 'Pending' ? 'error' : ''">{{ "First Payment Paid Date : " +
                row13.item.OfFirstPaymentDate }}</span>
            </template>
            <template slot="SOB" slot-scope="row14">
              <span :class="row14.item.SOB == 'Pending' ? 'error' : ''">{{
                "P44 : " + row14.item.SOB
              }}</span><br />
              <span :class="row14.item.SysSOB == 'Pending' ? 'error' : ''">{{
                "Sys : " + row14.item.SysSOB
              }}</span>
            </template>
            <template slot="SysETA_actual" slot-scope="row15">
              <span :class="row15.item.EtaDestinationEstimated == 'Pending' ? 'error' : ''">{{
                "OF ETA Estimated : " + row15.item.EtaDestinationEstimated
              }}</span><br />
              <span :class="row15.item.EtaDestinationActual == 'Pending' ? 'error' : ''">{{
                "OF ETA Actual : " + row15.item.EtaDestinationActual
              }}</span><br />
              <span :class="row15.item.SysETA_estimated == 'Pending' ? 'error' : ''">{{
                "Sys ETA Estimated : " + row15.item.SysETA_estimated
              }}</span><br />
              <span :class="row15.item.SysETA_actual == 'Pending' ? 'error' : ''">{{
                "Sys ETA Actual : " + row15.item.SysETA_actual
              }}</span><br />
              <span :class="row15.item.EtaLoadPortInitial == 'Pending' ? 'error' : ''">{{
                "OF ETA Load Port Initial : " + row15.item.EtaLoadPortInitial
              }}</span><br />
              <span :class="row15.item.EtaLoadPortActual == 'Pending' ? 'error' : ''">{{
                "OF ETA Load Port Actual : " + row15.item.EtaLoadPortActual
              }}</span><br />
            </template>
            <!-- Repeat similar improvements for the remaining slots -->

          </b-table>
          <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
        </div>
      </div>

      <b-modal size="xl" id="doc" class="modal-dialog-doc" no-close-on-esc no-close-on-backdrop ref="doc-modal"
        hide-footer :title="'Assignment Summary & Documents - ' + JOBSERIES">
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close
        </b-button>
      </b-modal>
      <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
    </b-card>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import DateRangePicker from "vue2-daterange-picker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE_DOC } from "../../helper/constant.js";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";

import UpdateCBModal from '../Pendency/UpdateCBModal.vue';
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import userBasedClient from "../common/userBasedClient.vue";
import CustomLoader from "../common/customLoader.vue";
import NodeLockPannelService from "../../services/NodeLockPannelService";
import MasterService from "../../services/MasterService";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllFilterBranchList",
      JSON.stringify({
        filter: "getFilterBranchList",
        active: "all",
      })
    );
    this.initializePage();
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  data() {
    return {
      PrealertStatusList: [
        {
          inv: "1",
          int: "Yes",
        },
        {
          inv: "0",
          int: "No",
        },
        {
          inv: "2",
          int: "All",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "0",
          int: "Not Sailed",
        },
        {
          inv: "2",
          int: "All",
        },
      ],
      BillingStatusList: [
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "2",
          int: "All",
        },
      ],
      isModalOpen: false,
      cb_data: {
        common_id: 0,
        allModuleId: 0,
        booking_id: 0,
        getin_due_date: '',
        si_submission_date: '',
        vgm_submission_date: '',
        tr_submission_date: '',
        liner_bl_release_status: 0,
        line_inv_status: 0,
      },

      ALLMODULE: "",
      JOBSERIES: "",
      visible: false,
      isLoading: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 50,
      pageOptions: [100, 200, 300],
      filter: null,
      docURL: URL_BASE_DOC,
      ExcelBtnName: "Export As Excel",
      ExcelBtnNameCustom: "SI VGM Pending",
      is_custom_excel: 0,
      activeButtonBranch: this.$sessionsStorage.get("branchclientPre") === "1",
      Filter: {
        userFilter: "",// this.$sessionsStorage.get("userId"),
        prealertStatus: "",
        SobFilter: "",
        isFinalBillingStatus: "",
        branchFilter: (this.$sessionsStorage.get('designation') != 'Admin' && this.$sessionsStorage.get('userId') != 13) ? this.$sessionsStorage.get('branch_baseLocation') : "",
        SiDueDateFilter: "",
        TrDueDateFilter: "",
        VgmDueDateFilter: "",
        // liner_bl_release_statusFilter: 0, line_inv_statusFilter: 0,
        commonFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      generateExcel: '0',
      columnMain: this.initializeColumns(),
      JOBList: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      debounce: null, // Debounce timer
      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      activeButtonBranch: this.$sessionsStorage.get("branchclientPre") == "1" ? true : false,
      activeUserPreference: this.$sessionsStorage.get("user_pre") === "1" ? true : false,

      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),

      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      createdAtRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      lineInvoiceStatus: [
        { label: "Not Received from Line", value: 1 },
        { label: "Not Initiated", value: 0 },
        { label: "Paid", value: 2 },
        { label: "Dispute Raised", value: 3 },
        { label: "Send for Payment", value: 4 }
      ],
      mblInvoiceStatus: [
        { label: "Released", value: 1 },
        { label: "Sailed - NOT RELEASED", value: 0 },
        { label: "NOT RELEASED", value: 2 },
      ],
    };
  },
  computed: {
    next7Days() {
      const dates = [];
      const today = new Date();
      // Single entry for the previous 7 days
      dates.push({
        label: "Previous 7 Days",
        value: "-7"
      });
      for (let i = 0; i < 7; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);

        let label;
        if (i === 0) label = "Today";
        else if (i === 1) label = "Tomorrow";
        else label = date.toLocaleDateString("en-US", { weekday: 'long' }); // e.g., "Monday"
        // Construct the value in DD/MM/YYYY format
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        const formattedDate = `${day}-${month}-${year}`;
        const formattedDateUlta = `${year}-${month}-${day}`;
        dates.push({
          label: `${label} (${formattedDate})`,
          value: formattedDateUlta // Formats as 'YYYY-MM-DD'
        });
      }
      return dates;
    }
  },
  components: {
    UpdateCBModal,
    ContainerSummary,
    JobWisePaymentsDetails,
    ContaierWebLogSummary,
    RejectInvTallyBillSummary,
    InvExpSummary,
    AssignmentSummary,
    DocForm,
    userBasedClient,
    ModelListSelect,
    CustomLoader,

    DatePicker,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },

  methods: {
    openModal(item) {
      this.cb_data = {
        common_id: item.common_id,
        allModuleId: item.allModuleId,
        JOBNO: item.JobNo,
        booking_id: item.booking_id,
        getin_due_date: item.common_getin_due_date || item.cb_getin_due_date,
        si_submission_date: item.common_si_submission_date || item.cb_si_submission_date,
        vgm_submission_date: item.common_vgm_submission_date || item.cb_vgm_submission_date,
        tr_submission_date: item.common_tr_submission_date || item.cb_tr_submission_date,
        liner_bl_release_status: item.common_liner_bl_release_status || item.cb_liner_bl_release_status,
        line_inv_status: item.common_line_inv_status || item.cb_line_inv_status,
        linerBLNumber: item.MblNo || '',
        blType: item.blType || '',
        frghtTermsLiner: item.frghtTermsLiner || '',
        linerBLupload: item.linerBLupload || '',
        mbl_release_date: item.mbl_release_date || '',
        mbl_date: item.mbl_date || '',
        FBLCreatedBy: item.FBLCreatedBy || '',
        FBLloginTime: item.FBLloginTime || '',
        FBLupdatedBy: item.FBLupdatedBy || '',
        FBLupdateTime: item.FBLupdateTime || '',
      };
      // console.log('this.cb_data=>', this.cb_data);
      // this.isModalOpen = true;
      this.$refs.updateCBModal.show(this.cb_data);
    },
    updateData(updatedData) {
      this.cb_data = updatedData;
      // console.log('updatedData=>', this.cb_data);
      // return false;
      NodeLockPannelService.updateUnUsedBookingStatus(this.cb_data)
        .then((response) => {
          const { data, status, statusText } = response;
          // console.log("data PS=>", data);

          if (status == 200 && data.status == true) {
            this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.JobNo;
      // console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String("04").padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.createdAtRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },
    clearFilter() {
      this.Filter = {
        userFilter: "",//this.$sessionsStorage.get("userId"),
        prealertStatus: "",
        SobFilter: "",
        isFinalBillingStatus: "",
        branchFilter: (this.$sessionsStorage.get('designation') != 'Admin' && this.$sessionsStorage.get('userId') != 13) ? this.$sessionsStorage.get('branch_baseLocation') : "",
        SiDueDateFilter: "",
        TrDueDateFilter: "",
        VgmDueDateFilter: "",
        liner_bl_release_statusFilter: 0, line_inv_statusFilter: 0,
        commonFilter: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },
    goToSubscriptionPage(item) {
      if (item.SubscriptionId) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.SubscriptionId,
        });
      }
    },
    BranchBtnFilter(type) {
      this.activeButtonBranch = !type;

      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },
    filterClear() {
      this.Filter = {
        userFilter: "",
      };
    },
    goVGMPage(item) {
      if (item.isConsolidation == "0") {
        if (item.newContainerFlow == "1") {
          this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
          this.$sessionsStorage.set("editFFExecutionId", item.ffExecutionId);
          this.$sessionsStorage.set("editFFBookingId", item.ffBookingId);
          if (item.stuffingType == "factoryStuffing") {
            this.$router.push({
              path: "/freightForward/newffExecution",
            });
          } else {
            this.$router.push({
              path: "/freightForward/newFFexecutionWareHouse",
            });
          }
        }
      } else if (item.isConsolidation == "1") {
        this.$sessionsStorage.set("editffFclConsoExportId", item.ffExportFclId);
        this.$sessionsStorage.set("editffConExecutionId", item.ffExecutionId);
        this.$sessionsStorage.set("editconFclBookingId", item.ffBookingId);
        this.$router.push({
          path: "/ffExportCon/executionWHStuffingIcdCon",
        });
      }
    },
    initializePage() {
      this.getCurrentLastDate();
      lastVisitPage(this.$router.history.current.fullPath);
      const loginId = this.$sessionsStorage.get("loginId");
      if (!loginId) return this.$router.push({ path: "/Login/" });

      this.$store.dispatch("setCurrentRoute", this.$route.path);
      if (globalPermissionStatus("Sea Freight")) {
        this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
      } else {
        this.$router.push({ path: "/dashboard" });
      }

      this.$store.dispatch("common/setAllUserList", JSON.stringify({ itemCode: "GET_USERLIST_Data" }));
    },

    initializeColumns() {
      return [
        { key: "SN", mainkey: "SN", label: "SN.", sortable: true, table: "HJ." },
        { key: "RaisedFrom", mainkey: "RaisedFrom", label: "Branch", sortable: true, table: "A." },
        { key: "BookingNo", mainkey: "BookingNo", label: "Booking No", sortable: true, table: "B." },
        { key: "JOBNO", mainkey: "JOBNO", label: "JOB Details", sortable: true, table: "C." },
        { key: "clientName", mainkey: "clientName", label: "Client", sortable: true, table: "D." },
        { key: "shippingLine", mainkey: "shippingLine", label: "Sline", sortable: true, table: "E." },
        { key: "POR", mainkey: "POR", label: "POR - POL - POD", sortable: true, table: "F." },
        { key: "vgmcut_off_date_est", mainkey: "vgmcut_off_date_est", label: "VGM Date/Cutoff", sortable: true, table: "J." },
        { key: "si_cutoff_est", mainkey: "si_cutoff_est", label: "SI Date/Cutoff", sortable: true, table: "K." },
        { key: "tr_cutoff_date_est", mainkey: "tr_cutoff_date_est", label: "TR Date/CutOFF", sortable: true, table: "L." },
        { key: "handoverDate_actual", mainkey: "handoverDate_actual", label: "Handover Date/CutOFF", sortable: true, table: "L." },
        { key: "oe_payment_status", mainkey: "oe_payment_status", label: "Sline Payment Date", sortable: true, table: "M." },
        { key: "SOB", mainkey: "SOB", label: "SOB", sortable: true, table: "N." },
        { key: "SysETA_actual", mainkey: "SysETA_actual", label: "ETA Destination(Actual, Estimated)", sortable: true, table: "O." },
      ];
    },

    toggleBranchFilter(type) {
      this.activeButtonBranch = !type;
      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },
    goPage(item) {
      if (item.isConsolidation == "0") {
        if (item.newContainerFlow == "1") {
          this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
          this.$router.push({
            path: "/freightForward/newffExportFcl",
          });
        } else {
          this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
          this.$router.push({
            path: "/freightForward/ffExportFcl",
          });
        }
      } else if (item.isConsolidation == "1") {
        this.$sessionsStorage.set("editffFclConsoExportId", item.ffExportFclId);
        this.$router.push({
          path: "/ffExportCon/ffExportFclConsolidation",
        });
      }
    },
    goVGMPage(item) {
      if (item.isConsolidation === "0") {
        const { ffExportFclId, ffExecutionId, ffBookingId, stuffingType, newContainerFlow } = item;
        this.$sessionsStorage.set("editExportFCLId", ffExportFclId);
        this.$sessionsStorage.set("editFFExecutionId", ffExecutionId);
        this.$sessionsStorage.set("editFFBookingId", ffBookingId);
        const path = stuffingType === "factoryStuffing" ? "/freightForward/newffExecution" : "/freightForward/newFFexecutionWareHouse";
        this.$router.push({ path });
      } else {
        this.$sessionsStorage.set("editffFclConsoExportId", item.ffExportFclId);
        this.$sessionsStorage.set("editffConExecutionId", item.ffExecutionId);
        this.$sessionsStorage.set("editconFclBookingId", item.ffBookingId);
        this.$router.push({ path: "/ffExportCon/executionWHStuffingIcdCon" });
      }
    },

    debounceSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.getAssignmentPendencyList("Normal", "0", "0", "1", "1"), 500);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getAssignmentPendencyList("Excell", "0", "0", "1", "1");
    },
    getReportsCustom(id, btnName) {
      this.isLoading = true;
      this.is_custom_excel = "1";
      this.generateExcel = "1";
      this.ExcelBtnNameCustom = "Downloading Please Wait .....";
      this.getAssignmentPendencyList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAssignmentPendencyList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      // console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getAssignmentPendencyList("Normal", "0", CURRENT, "2", event);
    },
    getAssignmentPendencyList(type, filterId, currentPage, searchType, pageNumber) {
      this.totalData = 0;
      this.JOBList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getBookingResp",
        type: type,
        // fromSearch: SEARCH,
        // currentPage: CURRENT,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        is_custom_excel: this.is_custom_excel,
        record_type: "",
        is_client_template: 1,
        activeButtonBranch: this.activeButtonBranch,
      };
      // Set responseType to 'blob' if generating Excel
      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      NodeLockPannelService.getAllCommonJobList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data);

          if (status == 200 && data) {
            if (this.generateExcel == "1") {

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "get-Job-Pendency-panel-report.xlsx"); // Specify the file name
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.ExcelBtnNameCustom = "SI VGM Pending";
              this.generateExcel = "0";
              this.is_custom_excel = "0";
              this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.total;
                this.JOBList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    goBack() {
      window.history.go(-1);
    },

    sendSlinePaymentRequest() {
      // this.isLoading = true;
      MasterService.sendSlinePayment({})
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200) {
            // this.isLoading = false;
          }
        })
        .catch((error) => {
          console.log("Catch on sendSlinePaymentRequest Error: ", error);
        });
    },

    clearSearchFilter() {
      this.filter = "";
      this.getAssignmentPendencyList("Normal", "0", "0", "1", "1");
    },
    shouldBlink: function (item) {
      return item.CustomColorColumn === "red";
    },
    isBlinking: function (item) {
      return item.CustomColorColumn === "red";
    },
  },
};
</script>

<style>
.table-background thead {
  background-color: #a9e4ce;
  border-color: lightgrey;
  border-width: 2px;
  height: 40px;
  position: sticky;
  top: 0;
  font-size: 11px;
}

.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

.md-body-1,
.pendencyBody {
  font-size: 11px;
  font-weight: 400;
}

.table-background>tbody {
  font-size: 11px;
}

.table-background>thead {
  color: black;
}

.status-alerts {
  font-size: 18px;
}

.alert-danger-text {
  color: #d9534f;
}

.alert-info-text {
  color: #2a6fde;
}

.blink {
  animation: blinker 1s linear infinite;
  font-weight: 800;
  color: red;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// jobCommonPendency.vue?75cfedcc